(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/campaign/assets/client-api.js') >= 0) return;  svs.modules.push('/components/numbergames/campaign/assets/client-api.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  productMapping
} = svs.numbergames;
const {
  DRAW_STATE,
  DRAW_TYPE
} = svs.numbergames.campaign.CONSTANTS;
const logger = svs.numbergames.campaign.logger;
const {
  getValidProduct,
  getValidDrawTypesByProduct,
  getValidYear,
  getValidMonth
} = svs.numbergames.campaign.internal.utils;
const {
  getDraws,
  calculateChances,
  calculateChancesWithoutCampaign
} = svs.numbergames.campaign.internal.client_api_utils;
const campaignsSingleton = svs.numbergames.campaign.internal.campaignsSingleton;
function getValidOptions(_ref) {
  let {
    product,
    draw,
    draws,
    date,
    dateInterval,
    endDateInterval,
    year,
    month,
    drawTypeId,
    drawTypeIds,
    drawStateId,
    drawStateIds,
    wager
  } = _ref;
  const getValidInterval = interval => {
    const startDate = interval.start;
    const endDate = interval.end;
    if (startDate && endDate && new Date(startDate) < new Date(endDate)) {
      return {
        startDate,
        endDate
      };
    }
  };
  const validProduct = getValidProduct(product);
  if (!validProduct) {
    if (!productMapping.getProductId(product)) {
      logger.debug('CampaignApi validate options: No valid product. Provided product was:', product);
    }
    return;
  }
  if (draw || draws) {
    draws = getDraws(draws || draw, wager);
    if (!draws.every(draw => productMapping.isSameProduct(draw.productItsId, validProduct) && draw.drawNumber && draw.drawCount)) {
      logger.debug('CampaignApi validate options: Invalid draws.');
      return;
    }
  }
  if (date) {
    if (!dateFns.isValid(new Date(date))) {
      logger.debug('CampaignApi validate options: Invalid date.');
      return;
    }
  }
  if (dateInterval) {
    dateInterval = getValidInterval(dateInterval);
    if (!dateInterval) {
      logger.debug('CampaignApi validate options: Invalid dateInterval.');
      return;
    }
  }
  if (endDateInterval) {
    endDateInterval = getValidInterval(endDateInterval);
    if (!endDateInterval) {
      logger.debug('CampaignApi validate options: Invalid endDateInterval.');
      return;
    }
  }
  if (year && month) {
    year = getValidYear({
      year
    });
    month = getValidMonth({
      month
    });
    if (!year || !month) {
      logger.debug('CampaignApi validate options: Invalid year or month.');
      return;
    }
  }
  if (drawTypeId || drawTypeIds) {
    drawTypeIds !== null && drawTypeIds !== void 0 ? drawTypeIds : drawTypeIds = drawTypeId;
    drawTypeIds = Array.isArray(drawTypeIds) ? drawTypeIds : [drawTypeIds];
    const drawTypes = getValidDrawTypesByProduct(validProduct);
    if (!drawTypeIds.every(drawTypeId => drawTypes.includes(drawTypeId))) {
      const allDrawTypes = Object.values(DRAW_TYPE);
      if (!drawTypeIds.every(drawTypeId => allDrawTypes.includes(drawTypeId))) {
        logger.debug('CampaignApi validate options: Invalid drawType or drawTypes.');
      }
      return;
    }
  }
  if (drawStateId || drawStateIds) {
    drawStateIds !== null && drawStateIds !== void 0 ? drawStateIds : drawStateIds = drawStateId;
    drawStateIds = Array.isArray(drawStateIds) ? drawStateIds : [drawStateIds];
    const drawStates = Object.values(DRAW_STATE);
    if (!drawStateIds.every(drawStateId => drawStates.includes(drawStateId))) {
      logger.debug('CampaignApi validate options: Invalid drawState or drawStates');
      return;
    }
  }
  return {
    product: validProduct,
    draws,
    date,
    dateInterval,
    endDateInterval,
    year,
    month,
    drawTypeIds,
    drawStateIds,
    wager
  };
}
function findCampaigns(getValue, options) {
  options = getValidOptions(options);
  if (!options) {
    return;
  }
  const campaigns = campaignsSingleton.findCampaigns(options);
  if (!(campaigns !== null && campaigns !== void 0 && campaigns.length)) {
    return;
  }
  return getValue({
    campaign: campaigns[0],
    campaigns
  }, options);
}
async function fetchCampaigns(getValue, options) {
  options = getValidOptions(options);
  if (!options) {
    return;
  }
  const campaigns = await campaignsSingleton.fetchCampaigns(options);
  if (!(campaigns !== null && campaigns !== void 0 && campaigns.length)) {
    return;
  }
  return getValue({
    campaign: campaigns[0],
    campaigns
  }, options);
}
const hasCampaign = _ref2 => {
  let {
    campaign
  } = _ref2;
  return Boolean(campaign);
};
const hasOpenCampaign = _ref3 => {
  let {
    campaign
  } = _ref3;
  return campaign.drawStateId === DRAW_STATE.OPEN;
};
const isCampaignFinalized = _ref4 => {
  let {
    campaign
  } = _ref4;
  return campaign.drawStateId === DRAW_STATE.FINALIZED || dateFns.isAfter(new Date(), new Date(campaign.drawDate));
};
const isPeriodicCampaign = _ref5 => {
  let {
    campaign
  } = _ref5;
  return campaign.drawTypeId === DRAW_TYPE.PERIODIC;
};
const getCampaignName = _ref6 => {
  let {
    campaign
  } = _ref6;
  return campaign.name;
};
const getCampaignStartDate = _ref7 => {
  let {
    campaign
  } = _ref7;
  return campaign.startDate;
};
const getCampaignEndDate = _ref8 => {
  let {
    campaign
  } = _ref8;
  return campaign.endDate;
};
const getCampaignDrawDate = _ref9 => {
  let {
    campaign
  } = _ref9;
  return campaign.drawDate;
};
const getCampaignDrawNumber = _ref0 => {
  let {
    campaign
  } = _ref0;
  return campaign.drawNumber;
};
const getCampaignWinPlan = _ref1 => {
  let {
    campaign
  } = _ref1;
  return campaign.winDivs;
};
const getCampaignUrl = _ref10 => {
  let {
    campaign
  } = _ref10;
  return campaign.url;
};
const getCampaignImages = _ref11 => {
  let {
    campaign
  } = _ref11;
  return {
    smallImageUrl: campaign.smallImageUrl,
    largeImageUrl: campaign.largeImageUrl
  };
};
const getCampaign = _ref12 => {
  let {
    campaign
  } = _ref12;
  return _objectSpread({
    campaignName: getCampaignName({
      campaign
    }),
    startDate: getCampaignStartDate({
      campaign
    }),
    endDate: getCampaignEndDate({
      campaign
    }),
    drawDate: getCampaignDrawDate({
      campaign
    }),
    drawNumber: getCampaignDrawNumber({
      campaign
    }),
    isOpen: hasOpenCampaign({
      campaign
    }),
    isFinalized: isCampaignFinalized({
      campaign
    }),
    winplan: getCampaignWinPlan({
      campaign
    }),
    url: getCampaignUrl({
      campaign
    })
  }, getCampaignImages({
    campaign
  }));
};
const getWinningLocationTexts = _ref13 => {
  var _campaign$winningLoca;
  let {
    campaign
  } = _ref13;
  const WAGER_TYPES = {
    ONLINE: 'OwnOnline',
    SUBSCRIPTION: 'OwnOnlineSubscribe',
    RETAIL: 'OwnRetail',
    SYNDICATE: 'BolagOnline',
    FRACTION_ONLINE: 'FractionOnline',
    FRACTION_RETAIL: 'FractionRetail'
  };

  return (_campaign$winningLoca = campaign.winningLocations) === null || _campaign$winningLoca === void 0 ? void 0 : _campaign$winningLoca.map(_ref14 => {
    let {
      wagerType,
      city
    } = _ref14;
    const prefix = 'Veckans miljonvinst gick till';
    switch (wagerType) {
      case WAGER_TYPES.ONLINE:
      case WAGER_TYPES.RETAIL:
        return [prefix, "en vinnare i ".concat(city)];
      case WAGER_TYPES.SUBSCRIPTION:
        return [prefix, "en prenumerant i ".concat(city)];
      case WAGER_TYPES.SYNDICATE:
        return [prefix, "ett lagspel i ".concat(city)];
      case WAGER_TYPES.FRACTION_ONLINE:
        return [prefix, 'ett andelsspel sålt online'];
      case WAGER_TYPES.FRACTION_RETAIL:
        return [prefix, "ett andelsspel s\xE5lt i ".concat(city)];
      default:
    }
  }).filter(Boolean);
};
const campaignApi = {
  calculateChances,
  hasCampaign,
  hasOpenCampaign,
  isCampaignFinalized,
  isPeriodicCampaign,
  getCampaignName,
  getCampaignStartDate,
  getCampaignEndDate,
  getCampaignDrawDate,
  getCampaignDrawNumber,
  getCampaignWinPlan,
  getCampaignUrl,
  getCampaignImages,
  getCampaign,
  getWinningLocationTexts
};
Object.entries(campaignApi).forEach(_ref15 => {
  let [functionName, getValueFunction] = _ref15;
  svs.numbergames.campaign.openCampaignApi[functionName] = (product, options) => findCampaigns(getValueFunction, _objectSpread(_objectSpread({}, options), {}, {
    product,
    drawStateIds: [DRAW_STATE.DEFINED, DRAW_STATE.OPEN]
  }));
  svs.numbergames.campaign.asyncOpenCampaignApi[functionName] = async (product, options) => await fetchCampaigns(getValueFunction, _objectSpread(_objectSpread({}, options), {}, {
    product,
    drawStateIds: [DRAW_STATE.DEFINED, DRAW_STATE.OPEN]
  }));
  svs.numbergames.campaign.campaignApi[functionName] = (product, options) => findCampaigns(getValueFunction, _objectSpread(_objectSpread({}, options), {}, {
    product
  }));
  svs.numbergames.campaign.asyncCampaignApi[functionName] = async (product, options) => await fetchCampaigns(getValueFunction, _objectSpread(_objectSpread({}, options), {}, {
    product
  }));
});
svs.numbergames.campaign.campaignApi.calculateChancesWithoutCampaign = calculateChancesWithoutCampaign;

 })(window);